/** Build and download an .ics file for one event – works with Apple/Google/Outlook calendars. */
const pad = (n) => String(n).padStart(2, "0");
const esc = (s = "") => String(s).replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/[,;]/g, (m) => `\\${m}`);
const dateOnly = (iso) => iso.replace(/-/g, "");
const nextDay = (iso) => { const d = new Date(`${iso}T12:00:00`); d.setDate(d.getDate() + 1); return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; };
const local = (iso, time) => `${dateOnly(iso)}T${time.replace(":", "")}00`;

export const eventToIcs = (ev, { url, location } = {}) => {
  const start = ev.date;
  const end = ev.end_date || ev.date;
  const timed = !!ev.start_time;
  const dtstart = timed ? `DTSTART;TZID=Europe/Oslo:${local(start, ev.start_time)}` : `DTSTART;VALUE=DATE:${dateOnly(start)}`;
  const dtend = timed
    ? `DTEND;TZID=Europe/Oslo:${local(end, ev.end_time || (ev.start_time < "22:00" ? `${pad(Number(ev.start_time.slice(0, 2)) + 2)}${ev.start_time.slice(2)}` : "23:59"))}`
    : `DTEND;VALUE=DATE:${dateOnly(nextDay(end))}`;
  const stamp = new Date().toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
  const lines = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Halsnøy Kulturhus//Arrangement//NN", "CALSCALE:GREGORIAN", "METHOD:PUBLISH",
    "BEGIN:VEVENT", `UID:${ev.id}@halsnoykulturhus`, `DTSTAMP:${stamp}`, dtstart, dtend,
    `SUMMARY:${esc(ev.title)}`,
    ev.summary || ev.description ? `DESCRIPTION:${esc((ev.summary || ev.description || "").slice(0, 900))}${url ? `\\n\\n${esc(url)}` : ""}` : null,
    location ? `LOCATION:${esc(location)}` : null,
    url ? `URL:${url}` : null,
    "END:VEVENT", "END:VCALENDAR",
  ].filter(Boolean);
  return lines.join("\r\n");
};

export const downloadIcs = (ev, opts) => {
  const blob = new Blob([eventToIcs(ev, opts)], { type: "text/calendar;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `${(ev.title || "arrangement").replace(/[^\w\dæøåÆØÅ -]+/g, "").trim().replace(/\s+/g, "-").toLowerCase()}.ics`;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { URL.revokeObjectURL(a.href); a.remove(); }, 500);
};

/** Pre-filled «add to Google Calendar» link for the same event. */
export const googleCalendarUrl = (ev, { url, location } = {}) => {
  const end = ev.end_date || ev.date;
  const endTime = ev.end_time || (ev.start_time && ev.start_time < "22:00" ? `${pad(Number(ev.start_time.slice(0, 2)) + 2)}${ev.start_time.slice(2)}` : "23:59");
  const dates = ev.start_time ? `${local(ev.date, ev.start_time)}/${local(end, endTime)}` : `${dateOnly(ev.date)}/${dateOnly(nextDay(end))}`;
  const p = new URLSearchParams({ action: "TEMPLATE", text: ev.title || "Arrangement", dates, ctz: "Europe/Oslo", details: `${(ev.summary || ev.description || "").slice(0, 900)}${url ? `\n\n${url}` : ""}`.trim() });
  if (location) p.set("location", location);
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
};
